import { createBrowserRouter, Navigate } from 'react-router-dom'

import { LandingPage } from '@/features/landing/landing.page'
import { adminAuthLoader, createPermissionLoader } from '@/hooks/use-admin-auth'

export const router = createBrowserRouter([
  {
    path: '/',
    children: [{ index: true, element: <LandingPage /> }],
  },

  {
    path: '/checkout/:plan',
    lazy: () =>
      import('@/features/checkout/checkout.page').then((m) => ({
        Component: m.CheckoutPage,
      })),
  },

  {
    path: '/checkout/obrigado/:paymentId',
    lazy: () =>
      import('@/features/checkout/payment-status.page').then((m) => ({
        Component: m.PaymentStatusPage,
      })),
  },

  {
    path: '/login',
    lazy: () => import('@/features/auth/login.page').then((m) => ({ Component: m.LoginPage })),
  },

  {
    path: '/admin',
    lazy: () => import('@/features/admin/admin-shell').then((m) => ({ Component: m.AdminShell })),
    loader: adminAuthLoader,
    children: [
      {
        index: true,
        loader: createPermissionLoader(['financeiro:read', 'admin:any']),
        lazy: () =>
          import('@/features/admin/admin-dashboard.page').then((m) => ({
            Component: m.AdminDashboardPage,
          })),
      },
      {
        path: 'financeiro',
        lazy: () =>
          import('@/features/admin/financeiro/financeiro.page').then((m) => ({
            Component: m.FinanceiroPage,
          })),
      },
      {
        path: 'clientes',
        loader: createPermissionLoader(['clientes:read', 'admin:any']),
        lazy: () =>
          import('@/features/admin/clientes/clientes.page').then((m) => ({
            Component: m.ClientesPage,
          })),
      },
      {
        path: 'leads',
        loader: createPermissionLoader(['submissions:read', 'admin:any']),
        lazy: () =>
          import('@/features/admin/leads/leads.page').then((m) => ({ Component: m.LeadsPage })),
      },
      {
        path: 'relatorios',
        loader: createPermissionLoader([
          'relatorios:read',
          'disparos:read',
          'disparos:write',
          'admin:any',
        ]),
        lazy: () =>
          import('@/features/admin/relatorios/relatorios.page').then((m) => ({
            Component: m.RelatoriosPage,
          })),
      },
      {
        path: 'integracoes',
        loader: createPermissionLoader(['integracoes:read', 'integracoes:write', 'admin:any']),
        lazy: () =>
          import('@/features/admin/integracoes/integracoes.page').then((m) => ({
            Component: m.IntegracoesPage,
          })),
      },
      {
        path: 'precos',
        lazy: () =>
          import('@/features/admin/precos.page').then((m) => ({ Component: m.PrecosPage })),
      },
      {
        path: 'usuarios',
        loader: createPermissionLoader(['users:read', 'admin:any']),
        lazy: () =>
          import('@/features/admin/usuarios/users.page').then((m) => ({
            Component: m.AdminUsersPage,
          })),
      },
      {
        path: 'cargos',
        loader: createPermissionLoader(['roles:read', 'admin:any']),
        lazy: () =>
          import('@/features/admin/cargos/roles.page').then((m) => ({
            Component: m.AdminRolesPage,
          })),
      },
      {
        path: 'whatsapp',
        loader: createPermissionLoader(['whatsapp:read', 'whatsapp:write', 'admin:any']),
        lazy: () =>
          import('@/features/admin/whatsapp/whatsapp.page').then((m) => ({
            Component: m.WhatsappPage,
          })),
      },
      {
        path: 'campanhas',
        loader: createPermissionLoader(['campanhas:read', 'admin:any']),
        lazy: () =>
          import('@/features/admin/campanhas/campanhas.page').then((m) => ({
            Component: m.CampanhasPage,
          })),
      },
      {
        path: 'campanhas/:id',
        loader: createPermissionLoader(['campanhas:read', 'admin:any']),
        lazy: () =>
          import('@/features/admin/campanhas/campanha-detail.page').then((m) => ({
            Component: m.CampanhaDetailPage,
          })),
      },
    ],
  },

  { path: '*', element: <Navigate to="/" replace /> },
])
